import { DATA_PRODUCER_WORKSHEET_NAME } from "../globalValues";
import { getSecuritiesTableData } from "../sourceServices";
import { setProducerQuoteFeederOptions } from "./setProducerQuoteFeederOptions";
import {
  DATA_PRODUCER_TABLE_NAME,
  DEFAULT_BUTTON_TO_UPDATE_TEXT,
  DISABLED_BUTTON_TO_UPDATE_FILL_COLOR,
  DISABLED_BUTTON_TO_UPDATE_FONT_COLOR,
  ROW_ID_IDX,
  UPDATE_BUTTON_IDX,
} from "./constants";
import { createDataProducerTable } from "./createDataProducerTable";
import {
  SECURITIES_TABLE_ALIAS_COL_IDX,
  SECURITIES_TABLE_ISIN_COL_IDX,
  SECURITIES_TABLE_NAME_COL_IDX,
} from "../sourceServices/securitiesTable/config";
import { lockEditModeInSomeColumns } from "./lockEditModeInSomeColumns";
import { DEFAULT_EMPTY_CELL_VALUE } from "../config";

const generateId = (): string => {
  const characters = "0123456789";
  const idLength = 10;

  let id = "";

  for (let i = 0; i < idLength; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    id += characters.charAt(randomIndex);
  }

  return id;
};

async function buildInfoDataProducerTable(context: Excel.RequestContext, selectedSecurities: string[] | null = null) {
  const data = await getSecuritiesTableData(context);

  const dataSecurityTable = [];

  for (let i = 1; i < data.length; i++) {
    if (selectedSecurities != null && !selectedSecurities.includes(data[i][SECURITIES_TABLE_ISIN_COL_IDX])) {
      continue;
    }

    dataSecurityTable.push([
      generateId(),
      data[i][SECURITIES_TABLE_ISIN_COL_IDX],
      data[i][SECURITIES_TABLE_NAME_COL_IDX],
      data[i][SECURITIES_TABLE_ALIAS_COL_IDX],
      DEFAULT_EMPTY_CELL_VALUE,
      DEFAULT_EMPTY_CELL_VALUE,
      "None",
      null,
      DEFAULT_BUTTON_TO_UPDATE_TEXT,
      DEFAULT_EMPTY_CELL_VALUE,
      DEFAULT_EMPTY_CELL_VALUE,
      DEFAULT_EMPTY_CELL_VALUE,
      DEFAULT_EMPTY_CELL_VALUE,
    ]);
  }

  return dataSecurityTable;
}

export async function insertSecurityProducer(context: Excel.RequestContext, securities: string[]) {
  if (securities.length === 0) {
    return;
  }

  const dataToInsert = await buildInfoDataProducerTable(context, securities);

  const worksheet = context.workbook.worksheets.getItem(DATA_PRODUCER_WORKSHEET_NAME);
  let table = worksheet.tables.getItemOrNullObject(DATA_PRODUCER_TABLE_NAME);
  await context.sync();

  if (table.isNullObject) {
    await createDataProducerTable(context);
  }
  table = worksheet.tables.getItem(DATA_PRODUCER_TABLE_NAME);

  worksheet.protection.unprotect();

  const addedRow = table.rows.add(undefined, dataToInsert);
  table.getRange().format.autofitColumns();
  table.getRange().format.autofitRows();

  const buttonToUpdatePrice = addedRow.getRange().getColumn(UPDATE_BUTTON_IDX);
  const rowsBelow =
    securities.length > 1
      ? addedRow
          .getRange()
          .getRowsBelow(securities.length - 1)
          .getColumn(UPDATE_BUTTON_IDX)
      : null;

  [buttonToUpdatePrice, rowsBelow].forEach((cell) => {
    if (cell === null) return;

    cell.format.fill.color = DISABLED_BUTTON_TO_UPDATE_FILL_COLOR;
    cell.format.font.color = DISABLED_BUTTON_TO_UPDATE_FONT_COLOR;
    cell.format.font.bold = true;
  });

  await context.sync();

  setProducerQuoteFeederOptions(context, worksheet, table);

  table.getRange().getColumn(ROW_ID_IDX).columnHidden = true;

  await lockEditModeInSomeColumns();

  await context.sync();
}
